import _ from 'lodash'
import {
  STORE_PROPERTY,
  STORE_RECENT_SAVED_PROPERTIES,
  STORE_SAVED_PROPERTY_IDENTIFIERS,
  APPEND_SAVED_PROPERTY,
  SPLICE_SAVED_PROPERTY,
  UPDATE_PROPERTY_SAVE_STATUS,
  UPDATE_PROPERTY_LISTING,
} from '../constants/actionTypes'

/**
 * NOTE: This is the eventual structure of the property we will get from PAL.
 */
const initialState = {
  /**
   * This holds everything related to the main property this whole page is for.
   */
  property: {
    is_trustee: false,
    property_details: {},
    transaction_details: {},
    additional_details: {},
    documents: [],
  },

  /**
   * A list of recent properties the user saved -- for use in the UI
   */
  recentSavedAssets: [],

  /**
   * A list of ids of the properties users have already saved
   */
  savedAssetsIdentifiers: [],
}

export default function propertyReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_PROPERTY: {
      const is_trustee =
        action.isTrustee === undefined
          ? state.property.is_trustee
          : action.isTrustee
      return _.merge({}, state, {
        property: {
          ...action.property,
          is_trustee,
        },
      })
    }
    // TODO: Figure out if these are needed at all and wether they should be in this listing store property store or its own store

    case STORE_SAVED_PROPERTY_IDENTIFIERS:
      return _.merge({}, state, {
        savedAssetsIdentifiers: action.identifiers || [],
      })

    case STORE_RECENT_SAVED_PROPERTIES:
      return _.merge({}, state, {
        recentSavedAssets: action.properties || [],
      })

    case APPEND_SAVED_PROPERTY: {
      const id = action.property.property_id

      return _.merge({}, state, {
        savedAssetsIdentifiers: [...state.savedAssetsIdentifiers, String(id)],
        recentSavedAssets: [...state.recentSavedAssets, action.property],
      })
    }
    case SPLICE_SAVED_PROPERTY: {
      const savedAssetsIdentifiers = state.savedAssetsIdentifiers.filter(
        id => Number(id) !== Number(action.id)
      )
      const recentSavedAssets = state.recentSavedAssets.filter(property => {
        const id = property.property_id
        return Number(id) !== Number(action.id)
      })
      return {
        ...state,
        savedAssetsIdentifiers,
        recentSavedAssets,
      }
    }

    case UPDATE_PROPERTY_SAVE_STATUS: {
      const savedAssetsIdentifiers = new Set(action.propertyIds)
      const listing = _.cloneDeep(state.property.listing)
      listing.primary_property.is_currently_saved = savedAssetsIdentifiers.has(
        listing.primary_property.property_id
      )
      return {
        ...state,
        property: {
          ...state.property,
          listing: {
            ...listing,
          },
        },
      }
    }

    case UPDATE_PROPERTY_LISTING: {
      const stateListing = _.cloneDeep(state.property.listing)
      return {
        ...state,
        property: {
          ...state.property,
          listing: {
            ...stateListing,
            ...action.listing,
          },
        },
      }
    }

    default:
      return state
  }
}

export { initialState }
